import { Message } from "../model";
import { apiClient, apiClientBlob, ApiResponse } from "@/shared/api";

export const getChatMessages = (
  chatId: string,
  page = 1
): Promise<ApiResponse<Message[]>> => {
  return apiClient(`/api/chats/${chatId}/messages?page=${page}&limit=100`, "get");
};

export const filesUpload = (
  formData: FormData
): Promise<ApiResponse<string>> => {
  return apiClient(`/api/files/upload`, "post", formData);
};


export const getfile = (fileName: string): Promise<Blob> => {
  return apiClientBlob(`/api/files/${fileName}`, "get");
};

export const getMessagesWithFiles = (chatId: string): Promise<ApiResponse<Message[]>> => {
  return apiClient(`/api/chats/${chatId}/messages?filesExists=1`, "get");
};

export const forwardMessage = (
  chatId: string,
  messagesIds: string[],
  targetChatIds: string[]
): Promise<ApiResponse<Message[]>> => {
  const formData = new FormData();
  
  formData.append("messages", messagesIds.join(","));
  formData.append("chats", targetChatIds.join(","));

  return apiClient(`/api/chats/${chatId}/messages/forward`, "post", formData);
};
export const getMessageById = async (
  chatId: string,
  messageId: string,
): Promise<ApiResponse<{success: boolean;
  found: Message;
  after: Message[];
  before: Message[];
  page: number;
}>> => {
  return apiClient(`api/chats/${chatId}/messages/goto/${messageId}?limit=100`, "get");
};